import { t } from "@/i18n-js/instance";
import { isValidURL } from "@/react/helpers/urlHelpers/isValidUrl";
import { Form } from "@circle-react-uikit/Form";

interface PostPurchaseCustomButtonUrlInputTextProps {
  isDisabled: boolean;
}

const ERROR_MESSAGES = {
  invalid: t(
    "settings.paywalls.modal.tabs.post_purchase.alerts.custom_button_url_is_invalid",
  ),
};

export const PostPurchaseCustomButtonUrlInputText = ({
  isDisabled,
}: PostPurchaseCustomButtonUrlInputTextProps) => (
  <Form.Item
    className="!mt-0 !py-0"
    name="post_purchase_email_meta.button_url"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    fullWidth
    hideBorder
    hideDescription
    rules={{
      validate: (input: string) =>
        input === "" || isValidURL(input) || ERROR_MESSAGES.invalid,
    }}
  >
    <Form.Input disabled={isDisabled} />
  </Form.Item>
);
